import defined from 'defined';

class Feature {
  // string -> Feature
  static features = new Map();

  static isEnabled(name) {
    const feature = this.features.get(name);
    return feature.isEnabled();
  }

  static add(feature) {
    this.features.set(feature.name, feature);
  }

  static getAllFeatures() {
    return Array.from(this.features.values());
  }

  static getAllTags() {
    const features = this.getAllFeatures();
    return features.filter(feature => feature.isTag);
  }

  static clear() {
    this.features.clear();
  }

  constructor(props = {}) {
    this.name = props.name;
    this.label = props.label;
    // boolean or string
    this.type = props.type || 'boolean';
    this.tags = props.tags || [];
    // represents the current value and is mutable
    this.value = props.getValue(this);
    // immutable
    Object.defineProperty(this, 'originalValue', {
      value: this.value,
      writable: false
    });
    Object.defineProperty(this, 'defaultValue', {
      value: props.getDefaultValue(this),
      writable: false
    });
  }

  isEnabled() {
    return defined(this.value, this.defaultValue);
  }

  hasTag(tag) {
    return this.tags.indexOf(tag) !== -1;
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/Feature.js